import React from 'react';
import { createTheme } from "../../design";
import { ThemeProvider } from '@emotion/react';
import { TooltipProvider } from '@radix-ui/react-tooltip';
import { GlobalStyles } from "./GlobalStyles";
import { DefaultLinkAs, LinkAsContext } from "../../internal";
import { RichTextEditorProvider } from "../../internal/RichTextEditorContext";
import { ToastQueueProvider } from "../../internal/ToastQueueProvider";
import { ToastArea } from "../../internal/ToastArea";
import { LangContext } from "../../internal/LanguageContext";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/**
 * The `CrystalProvider` should wrap around your entire application at the root
 * level.  It provides various "stuff" that Crystal needs, primarily the theme
 * object.
 *
 * If you're using emotion, you can access the crystal theme the way you would
 * access a regular emotion theme
 *
 * ### Example using styled syntax:
 * ```
 * const MyNicheCustomComponent = styled.div((theme) => {
 *   backgroundColor: theme.colors.bgPrimary
 * })
 * ```
 *
 * ### Example using css syntax
 * ```
 * return (
 *   <div css={(theme) => ({ backgroundColor: theme.colors.bgPrimary })}>Hello</div>
 * )
 * ```
 */
export function CrystalProvider(_ref) {
  var children = _ref.children,
    _ref$lang = _ref.lang,
    lang = _ref$lang === void 0 ? 'en-US' : _ref$lang,
    _ref$linkAs = _ref.linkAs,
    linkAs = _ref$linkAs === void 0 ? DefaultLinkAs : _ref$linkAs,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'light' : _ref$theme,
    _ref$forcePlainTextEd = _ref.forcePlainTextEditor,
    forcePlainTextEditor = _ref$forcePlainTextEd === void 0 ? false : _ref$forcePlainTextEd;
  return _jsx(ThemeProvider, {
    theme: createTheme(theme),
    children: _jsxs(LangContext.Provider, {
      value: lang,
      children: [_jsx(GlobalStyles, {}), _jsx(LinkAsContext.Provider, {
        value: linkAs,
        children: _jsx(TooltipProvider, {
          delayDuration: 0,
          children: _jsxs(ToastQueueProvider, {
            children: [_jsx(RichTextEditorProvider, {
              forcePlainTextEditor: forcePlainTextEditor,
              children: children
            }), _jsx(ToastArea, {})]
          })
        })
      })]
    })
  });
}